import React from 'react';
import './BrandPartners.css';
import chubbLogo from '../assets/images/chubb-logo.png';
import louisVuittonLogo from '../assets/images/louis-vuitton-logo.svg';
import rolexLogo from '../assets/images/rolex-logo.png';
import gucciLogo from '../assets/images/gucci-logo.png';
import luxuryBrandLogo from '../assets/images/luxury-brand-logo.png';

const BrandPartners = () => {
  return (
    <section className="brand-partners section">
      <div className="brand-partners-container">
        <div className="brand-partners-header">
          <h2 className="brand-partners-title">
            auctions from your favorite luxury brands and providers
          </h2>
        </div>
        
        <div className="brand-partners-logos">
          <div className="logo-item">
            <img src={chubbLogo} alt="Chubb" />
          </div>
          <div className="logo-item">
            <img src={louisVuittonLogo} alt="Louis Vuitton" />
          </div>
          <div className="logo-item">
            <img src={rolexLogo} alt="Rolex" />
          </div>
          <div className="logo-item">
            <img src={gucciLogo} alt="Gucci" />
          </div>
          <div className="logo-item">
            <img src={luxuryBrandLogo} alt="Luxury Brand" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandPartners;
